import moment from 'moment-timezone';
export default (date) => {
  return moment.utc(date).tz('Asia/Kuala_Lumpur').format('hh:mm A')
};
